//**** REACT
import React, { useCallback, useEffect, useState } from "react";
//Secciones
import Cabecera from "../CabeceraPie/Cabecera";
import PiePagina from "../CabeceraPie/PiePagina";

import Wizard from "components/Wizard/Wizard.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import Step1 from "./WizardSteps/Step1.js";
import Step2 from "./WizardSteps/Step2.js";
import Step3 from "./WizardSteps/Step3.js";

//**** Material-UI
import { makeStyles } from "@material-ui/core/styles";

//**** Estilos
import styles from "assets/jss/material-kit-pro-react/views/ecommerceSections/latestOffersStyle";
import { CertificadoActions } from "../../services";
import { Snackbar } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import PasswordConfirmation from "./PasswordConfirmation";

const useStyles = makeStyles(styles);

const getErrorDescription = (code) => {
  switch (code) {
    case "network":
      return "Ha ocurrido un error. Verifique su conexión.";
    case "E04":
      return "El certificado ha sido centralizado satisfactoriamente en la nube del SII.";
    case "E07":
      return "El Servicio de Impuestos Internos (SII) no está disponible.";
    default:
      return "No se pudo procesar la solicitud, comuníquese con contacto@firmadox.cl.";
  }
};

function prompt_before_unload(event) {
  event.preventDefault();
  event.returnValue = "";
}

export default function DescargaFes() {
  const classes = useStyles();

  const [isUIBusy, setUIBusy] = useState(false);

  const [extraData, setExtraData] = useState(null);

  const [errorCode, setErrorCode] = useState(null);
  const [message, setMessage] = useState(null);
  const [isMessageVisible, setMessageVisible] = useState(false);

  const [
    isPasswordConfirmationVisible,
    setPasswordConfirmationVisible,
  ] = useState(false);

  useEffect(() => {
    if (errorCode) {
      setMessage({ text: getErrorDescription(errorCode), severity: "error" });
    }
  }, [errorCode, setMessage]);

  useEffect(() => {
    setMessageVisible(message != null);
  }, [message, setMessageVisible]);

  const onClosePasswordPrompt = useCallback(
    () => setPasswordConfirmationVisible(false),
    [setPasswordConfirmationVisible]
  );

  const onExtraButtonClick = useCallback(
    () => setPasswordConfirmationVisible(true),
    [setPasswordConfirmationVisible]
  );

  const onCentralize = useCallback(() => {
    setUIBusy(true);
    setErrorCode(null);
    setMessage(null);

    window.addEventListener("beforeunload", prompt_before_unload);

    CertificadoActions.centralizarCertificado(extraData)
      .then((response) => {
        if (!response) {
          throw new Error("Empty response");
        }

        console.log(response);
        const { error } = response.payload;

        if (response.success) {
          setMessage({
            text:
              "El certificado ha sido centralizado satisfactoriamente en la nube del SII.",
            severity: "success",
          });

          setExtraData(null);
        } else {
          console.error(error);

          setErrorCode(error); // code
        }
      })
      .catch((reason) => {
        console.error(reason);

        setErrorCode("network");
      })
      .finally(() => {
        setUIBusy(false);

        window.removeEventListener("beforeunload", prompt_before_unload);
      });
  }, [extraData, setUIBusy, setErrorCode, setMessage, setExtraData]);

  return (
    <div>
      {extraData && (
        <PasswordConfirmation
          title={"Insertar Clave"}
          subtitle={
            "La clave para utilizar su certificado en el SII debe coincidir con la creada en el paso anterior."
          }
          isOpen={isPasswordConfirmationVisible}
          onClose={onClosePasswordPrompt}
          onSubmit={onCentralize}
          password={extraData["password"]}
        />
      )}

      <Cabecera color="gray" />
      <div className={classes.section}>
        <div className={classes.container}>
          <GridContainer justify="center">
            <GridItem xs={12} sm={8}>
              <Wizard
                onChangeBusyHandler={setUIBusy}
                showPreviusButton={false}
                changeTabs={false}
                validate
                steps={[
                  {
                    stepName: "Identificación",
                    stepComponent: Step1,
                    stepId: "identificacion",
                  },
                  {
                    stepName: "Credenciales",
                    stepComponent: Step2,
                    stepId: "credenciales",
                    componentProps: {
                      onChangeData: setExtraData,
                    },
                  },
                  {
                    stepName: "Descarga",
                    stepComponent: Step3,
                    stepId: "descarga",
                    componentProps: {
                      isExtraButtonDone: !extraData,
                    },
                  },
                ]}
                title="Bienvenido al proceso de descarga de certificados"
                subtitle=""
                finishButtonClick={(e) =>
                  (window.location.href = `${window.urlWP}`)
                }
                color="primary"
                isUIBusy={isUIBusy}
                extraButtonTitle={"Centralizar"}
                extraButtonBusyTitle={"Centralizando..."}
                extraButtonClick={extraData ? onExtraButtonClick : null}
              />
            </GridItem>

            <GridItem xs={12} sm={8} md={6}>
              {/*<div>{JSON.stringify({ message, isMessageVisible })}</div>*/}
              <Snackbar
                open={isMessageVisible}
                onClose={() => setMessageVisible(false)}
                autoHideDuration={9000}
              >
                {message !== null && (
                  <Alert
                    elevation={0}
                    variant="filled"
                    severity={message.severity}
                    style={{ width: "100%" }}
                  >
                    <div>{message.text}</div>
                  </Alert>
                )}
              </Snackbar>
            </GridItem>
          </GridContainer>
        </div>
      </div>
      <PiePagina />
    </div>
  );
}
